module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.9fa4a811.woff";